<!-- 地区选择组件 （省市二级选择、目前仅仅支持级联多选样式，区分于citySelect.vue 中使用的iview组件库 Cascader，该组件不支持级联多选） -->
<template>
    <div>
        <veui-select
            ref="city"
            v-model="curCity"
            class="city-select"
            multiple
            clearable
            searchable
            :placeholder="placeholder"
            :expanded="expanded"
            :max="max"
            @change="handleCityChange"
            @toggle="toggle"
        >
            <veui-option-group
                v-for="item, index in cityOptions"
                :key="item.key + index"
                :label="item.label"
                position="popup"
            >
                <veui-option
                    v-for="el, index in item.children"
                    :key="el.key + index"
                    :label="el.label"
                    :value="el.value"
                    :disabled="el.disabled"
                ></veui-option>
            </veui-option-group>
        </veui-select>
    </div>
</template>

<script>
import {Select, OptionGroup, Option} from 'veui';

export default {
    components: {
        'veui-select': Select,
        'veui-option-group': OptionGroup,
        'veui-option': Option
    },
    props: {
        // placeholder
        placeholder: {
            type: String,
            default: '请选择地域信息'
        },
        // 是否置灰默认选择地区之外的所有地区
        isGrayAll: {
            type: Boolean,
            default: false
        },
        // 最多选择个数
        max: {
            type: Number
        },
        // 默认选中地区
        userCity: {
            type: String,
            default: ''
        },
        // 是否反向选择
        isReverse: {
            type: Boolean,
            default: false
        }
    },
    watch: {
        userCity: {
            handler(newVal, oldVal) {
                if (newVal && newVal.length > 0) {
                    this.updateNum = this.updateNum + 1 + '';
                    let cityOptions = [...this.cityOptions];
                    let newCityOptions = [];
                    cityOptions.forEach(item => {
                        newCityOptions.push({
                            label: item.label,
                            key: item.label + this.updateNum,
                            children: item.children.map(items => {
                                return {
                                    label: items.label,
                                    value: items.label,
                                    key: items.label + '-' + this.updateNum,
                                    disabled: !this.isGrayAll
                                        ? false
                                        : (this.isReverse
                                            ? (newVal && newVal === items.label)
                                            : !!(newVal && newVal !== items.label))
                                };
                            })
                        });
                    });
                    this.cityOptions = newCityOptions;
                }
                (newVal && !this.isReverse) && (this.curCity = [newVal]);
            },
            deep: true,
            immediate: true
        }
    },
    data() {
        return {
            // 全国省市信息
            cityOptions: [],
            // 当前选择信息
            curCity: [],
            // 是否展开下拉框
            expanded: false,
            updateNum: 1
        };
    },
    created() {
        this.getCity();
    },
    mounted() {
        this.$nextTick(() => {
            this.cityObserver = this.handleIntersection(this.$refs.city.$el);
        });
    },
    destroyed() {
        this.cityObserver && this.cityObserver.disconnect();
    },
    methods: {
        // 获取全国省市信息
        getCity() {
            // 20240607 迁移新城市接口 - sun
            this.$http.get('/bp/api/city/cityAll?', {
            }).then(res => {
                res = this.$normalizeResponseData(res);
                if (!res) {
                    return;
                }
                this.handleCityData(res);
            }).catch(err => this.$normalizeResponseError(err));
        },
        // 处理省市信息
        handleCityData(data) {
            let cityOptions = [];
            this.updateNum = this.updateNum + 1 + '';
            data.forEach(item => {
                cityOptions.push({
                    label: item.label,
                    key: item.label + this.updateNum,
                    children: item.children.map(items => {
                        return {
                            label: items.label,
                            value: items.label,
                            key: items.label + '-' + this.updateNum,
                            disabled: !this.isGrayAll
                                ? false
                                : (this.isReverse
                                    ? (this.userCity && this.userCity === items.label)
                                    : !!(this.userCity && this.userCity !== items.label))
                        };
                    })
                });
            });
            this.cityOptions = cityOptions;
            (this.userCity && !this.isReverse) && (this.curCity = [this.userCity]);
        },
        handleCityChange(value) {
            this.$emit('cityChange', value);
        },

        // 下拉框的选择
        toggle(val) {
            this.expanded = val;
        },

        // 元素是否在视口的监听, 用于下拉框的关闭操作
        handleIntersection(element) {
            const observer = new IntersectionObserver(entries => {
                entries.forEach(entry => {
                    // 如果元素不在视口内，关闭下拉框的展开
                    if (!entry.isIntersecting) {
                        this.expanded = false;
                    }
                });
            });
            // 开始观察元素
            observer.observe(element);
            return observer;
        }
    }
};
</script>

<style lang="less" scoped>
.city-select {
    &.veui-select {
        width: 200px;
    }

    /deep/ .veui-input {
        min-height: 40px;
    }

    /deep/ .veui-tag {
        height: 28px;
        font-size: 14px;
    }
}
</style>